import React, { Fragment } from 'react';
import { Input, ModalHeader } from 'reactstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { formatDateDefault, DEFAULT_DATE_FORMAT } from 'services/DateFormatters';
import { PRIORITIES } from 'constants/lists';

export const inputFields = (data, initiatives, handleUserInput, handleDateInput) => {
    return (
        <Fragment>
            <div className="col-lg-9 d-flex flex-column order-lg-1">
                <h3 className="card-heading">{<IntlMessages id="label.name" />}</h3>
                <Input id="name" type="text" className={`form-control mb-2 ${data?.name ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.name} name="name"
                />
                <h3 className="card-heading">{<IntlMessages id="label.description" />}</h3>
                <Input id="description" type="text" className="form-control mb-2"
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.description} name="description"
                />
                <h3 className="card-heading">{<IntlMessages id="label.initiative" />}</h3>
                <Input
                    type="select"
                    name="initiativeId"
                    id="initiative"
                    className={data?.initiativeId ? 'is-valid' : 'is-invalid'}
                    onChange={(event) => handleUserInput(event)}
                    value={data?.initiativeId}
                >
                    <option key='emptySelect' value=''>-- select initiative --</option>
                    {initiatives.map((initiative) => {
                        return <option key={initiative.id} value={initiative.id}>{initiative.name}</option>;
                    })}
                </Input>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.priority" />}</h3>
                <Input
                    type="select"
                    name="priority"
                    id="priority"
                    onChange={(event) => handleUserInput(event)}
                    value={data?.priority}
                >
                    <option key='emptySelect' value=''>-- select priority --</option>
                    {PRIORITIES.map((priority) => {
                        return <option key={priority} value={priority}>{priority}</option>;
                    })}
                </Input>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.successIndicators" />}</h3>
                <Input id="succcessIndicators" type="text" className="form-control mb-2"
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.succcessIndicators} name="succcessIndicators"
                />
                <h3 className="card-heading mt-2">{<IntlMessages id="label.startDate" />}</h3>
                <div className="form-control">
                    <DayPickerInput
                        id="startDate"
                        value={formatDateDefault(data?.startDate)}
                        placeholder={DEFAULT_DATE_FORMAT}
                        onDayChange={(selectedDay) => handleDateInput('startDate', selectedDay)}
                        dayPickerProps={{
                            selectedDays: new Date(data?.startDate),
                        }}
                    />
                </div>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.endDate" />}</h3>
                <div className="form-control">
                    <DayPickerInput
                        id="endDate"
                        value={formatDateDefault(data?.endDate)}
                        placeholder={DEFAULT_DATE_FORMAT}
                        onDayChange={(selectedDay) => handleDateInput('endDate', selectedDay)}
                        dayPickerProps={{
                            selectedDays: new Date(data?.endDate),
                        }}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export const displayedImage = (selectedFeature) => {
    return (
        <div className="col-lg-3 text-center text-lg-right order-lg-2">
            <img id="thumb" className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={selectedFeature?.thumb || 'assets/images/features-1_225_225.jpg'} />
        </div>
    );
};

export const showErrors = (formErrors) => {
    if (formErrors) {
        return (
            <div className="panel panel-default">
                <FormErrors formErrors={formErrors} />
            </div>
        );
    }
    return null;
};

export const modalHeader = (title, modalHeaderOnClick) => {
    return (
        <ModalHeader className="modal-box-header bg-primary">
            {title}
            <span className="text-white pointer">
                <i className="zmdi zmdi-close zmdi-hc-lg" onClick={modalHeaderOnClick()} />
            </span>
        </ModalHeader>
    );
};


// WEBPACK FOOTER //
// ./components/Agile/feature/featureMaintenance/common.js